import { getApiGalaxyServer } from 'services';

export type SwitchTenantPayload = {
  tenant: string;
};

export type SwitchTenantSuccessResponse = {
  success: boolean;
};

export interface SwitchTenantErrorResponse {
  error: string;
  message: string;
  statusCode: number;
}

export const switchTenantApi = ({
  params: { tenant },
  token,
  config = {},
}: BaseApiParams<SwitchTenantPayload>) =>
  getApiGalaxyServer<SwitchTenantSuccessResponse>(
    `/rails_api/switch_tenant/${tenant}`,
    config,
    token,
  );
